import type { ApiReturnBlobResource } from '@highimpact-frontend/api-types';
import { Box, Typography } from '@mui/material';
import type { LegacyRef } from 'react';
import { forwardRef } from 'react';

export interface ApiReturnImageResource extends ApiReturnBlobResource {
  type: 'image';
}

export interface ImageDisplayerProps {
  image?: ApiReturnImageResource;
}

function ImageDisplayer(
  { image }: ImageDisplayerProps,
  _ref: LegacyRef<HTMLElement>
) {
  if (!image) {
    return (
      <Typography variant="body2" color="text.secondary">
        Ressource manquante
      </Typography>
    );
  }

  return (
    <Box
      className="image-displayer"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        overflow: 'hidden',
        p: 1,
        boxSizing: 'border-box',
      }}
    >
      <Box
        component="img"
        src={`data:image/png;base64,${image.value}`}
        alt={image.name}
        sx={{
          display: 'block',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          objectPosition: 'center',
        }}
      />
    </Box>
  );
}

export default forwardRef(ImageDisplayer);
